import { BLOCKS } from '@constants';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import Breadcrumbs from './breadcrumbs';
import HeadingStructureSubheader from './heading-structure';

const Subheader = () => {
	const { openedBlock } = useScannerWizardContext();

	return openedBlock === BLOCKS.headingStructure ? (
		<HeadingStructureSubheader />
	) : (
		<Breadcrumbs />
	);
};

export default Subheader;
